import React from 'react';

import { Navigate } from 'react-router';
import {
    BlankLayout,
    NotFound,
    Forbidden,
    Unauthorized,
    NoPrescriber,
} from '@europrocurement/flexy-components';
import { PostPaiement } from '@europrocurement/l2d-modules';
import Accueil from '../pages/Accueil/Accueil';
import PagePanier from '../pages/PagePanier/PagePanier';

const Router = [
    {
        path: '/',
        element: <BlankLayout />,
        children: [
            { path: '/', element: <Navigate to="/accueil" /> },
            {
                path: 'accueil',
                exact: true,
                element: <Accueil />,
            },
            {
                path: 'panier/:uuid',
                element: <PagePanier />,
            },
            {
                path: 'paiement-valide',
                exact: true,
                element: (
                    <PostPaiement
                        valide
                        type="recouvrement"
                    />
                ),
            },
            {
                path: 'paiement-invalide',
                exact: true,
                element: (
                    <PostPaiement
                        valide={false}
                        type="recouvrement"
                    />
                ),
            },
        ],
    },
    {
        path: '/errors',
        element: <BlankLayout />,
        children: [
            { path: '404', element: <NotFound /> },
            { path: '403', element: <Forbidden /> },
            { path: '401', element: <Unauthorized /> },
            {
                path: 'noPrescriber',
                element: <NoPrescriber />,
            },
        ],
    },
    {
        path: '*',
        element: <NotFound />,
    },
];

export default Router;
